"use client";
import React from "react";
import Link from "next/link";
import { ASSET_PREFIX } from "../../../../config";
import Image from "next/image";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

export default function Blogmain() {
  const DoctorVlogSwiper = () => {
    const images = [
      {
        src: `${ASSET_PREFIX}/assets/images/dr-kn-subramanian-namboothiri-cancer-treatment-ayurveda.webp`,
        alt: "Dr. K. N. Subramanian Namboothiri about Cancer Treatment in Ayurveda",
        link: "/blog-detail",
      },
      {
        src: `${ASSET_PREFIX}/assets/images/dr-jeevan-k-jose-rheumatoid-arthritis.webp`,
        alt: "Dr Jeevan K Jose Speaks about Rheumatoid Arthritis",
        link: "/blog-detail",
      },
      {
        src: `${ASSET_PREFIX}/assets/images/dr-jomy-joseph-speaks-karkidaka-treatment.webp`,
        alt: "Dr Jomy Joseph Speaks about Karkidaka Treatment",
        link: "/blog-detail",
      },
    ];

    return (
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        slidesPerView={1}
        spaceBetween={20}
        loop={true} // enables infinite scroll
        loopAdditionalSlides={images.length} // adds duplicates for smoother loop
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        pagination={{ clickable: true }}
        navigation={true}
        style={{ width: "100%", margin: "0 auto" }}
        breakpoints={{
          640: { slidesPerView: 1 },
          768: { slidesPerView: 2 },
          1024: { slidesPerView: 3 },
        }}>
        {images.concat(images).map((img, index) => (
          <SwiperSlide key={index}>
            <div className="rounded-[30px] overflow-hidden">
              <Link href="">
                <Image width={560} height={315} alt={img.alt} src={img.src} />
              </Link>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    );
  };
  return (
    <>
      <section className="pb-[100px]  max-2xl:pb-[80px]   max-xl:pb-[60px]  max-md:pb-[40px]">
        <div className="w-[90%] m-[auto]">
          <div className="grid grid-cols-3 max-mlg:grid-cols-2 max-sm:grid-cols-1 gap-[30px] max-2xl:gap-[20px]   mt-[60px]">
            <div className="group rounded-[30px] overflow-hidden relative">
              <div className="rounded-[10px] overflow-hidden">
                <Link
                  href={
                    "/your-ultimate-ayurvedic-medical-tourism-guide-in-2025"
                  }
                  className="block relative w-full h-[300px]">
                  <Image
                    fill
                    alt="Ayurvedic Medical Tourism Guide 2025"
                    src={`${ASSET_PREFIX}/assets/images/ayurvedic-medical-tourism-guide-2025.webp`}
                    className="w-full h-[300px] object-cover group-hover:scale-[1.1] transition duration-300 ease-linear"
                  />
                </Link>
              </div>

              <div className="text-[#60696e] p-2">
                <p
                  className="text-[#60696e] mt-[20px] mb-[14px] text-[22px] leading-[30px] font-light
      max-xxl:text-[20px] max-xxl:leading-[28px]
      group-hover:text-[#5d773d] transition-colors duration-300
      max-mlg:text-[18px] max-mlg:leading-[26px]
      max-xl:mt-[15px] max-xl:mb-[9px] overflow-hidden">
                  Your Ultimate Ayurvedic Medical Tourism Guide in 2025
                </p>
                <h2
                  className="text-[#60696e] my-[15px] text-[18px] leading-[26px]
      max-xxl:text-[18px] max-xxl:leading-[26px]
      max-mlg:text-[16px] max-mlg:leading-[24px]
      max-xl:my-[15px]">
                  Jul 25, 2025
                </h2>
              </div>
              <Link
                href={"/your-ultimate-ayurvedic-medical-tourism-guide-in-2025"}
                className="absolute w-[100%] h-full left-[0px] top-[0px]"></Link>
            </div>

            <div className="group rounded-[30px] overflow-hidden relative">
              <div className="rounded-[10px] overflow-hidden">
                <Link
                  href={
                    "/ultimate-guide-to-planning-an-ayurveda-wellness-retreat"
                  }
                  className="block relative w-full h-[300px]">
                  <Image
                    fill
                    alt="Ayurveda Wellness Retreat"
                    src={`${ASSET_PREFIX}/assets/images/ayurveda-wellness-retreat.webp`}
                    className="w-full h-[300px] object-cover group-hover:scale-[1.1] transition duration-300 ease-linear"
                  />
                </Link>
              </div>

              <div className="text-[#60696e] p-2">
                <p
                  className="text-[#60696e] mt-[15px] mb-[14px] text-[22px] leading-[30px] font-light
      max-xxl:text-[20px] max-xxl:leading-[28px]
      group-hover:text-[#5d773d] transition-colors duration-300
      max-mlg:text-[18px] max-mlg:leading-[26px]
      max-xl:mt-[15px] max-xl:mb-[9px] overflow-hidden">
                  Ultimate Guide To Planning An Ayurveda Wellness Retreat
                </p>
                <h3
                  className="text-[#60696e] my-[20px] text-[18px] leading-[26px]
      max-xxl:text-[18px] max-xxl:leading-[26px]
      max-mlg:text-[16px] max-mlg:leading-[24px]
      max-xl:my-[15px]">
                  Mar 11, 2025
                </h3>
              </div>
              <Link
                href={
                  "/ultimate-guide-to-planning-an-ayurveda-wellness-retreat"
                }
                className="absolute w-[100%] h-full left-[0px] top-[0px]"></Link>
            </div>
            <div className="group rounded-[30px] overflow-hidden relative">
              <div className="rounded-[10px] overflow-hidden">
                <Link
                  href={
                    "/what-to-expect-a-simple-panchakarma-treatment-guide-for-2025"
                  }
                  className="block relative w-full h-[300px]">
                  <Image
                    fill
                    alt="Panchakarma Treatment Guide for 2025"
                    src={`${ASSET_PREFIX}/assets/images/panchakarma-treatment-guide-2025.webp`}
                    className="w-full h-[300px] object-cover group-hover:scale-[1.1] transition duration-300 ease-linear"
                  />
                </Link>
              </div>

              <div className="text-[#60696e] p-2">
                <p
                  className="text-[#60696e] mt-[20px] mb-[14px] text-[22px] leading-[30px] font-light
      max-xxl:text-[20px] max-xxl:leading-[28px]
      group-hover:text-[#5d773d] transition-colors duration-300
      max-mlg:text-[18px] max-mlg:leading-[26px]
      max-xl:mt-[15px] max-xl:mb-[9px] overflow-hidden">
                  What to Expect? A Simple Panchakarma Treatment Guide for 2025
                </p>
                <h3
                  className="text-[#60696e] my-[15px] text-[18px] leading-[26px]
      max-xxl:text-[18px] max-xxl:leading-[26px]
      max-mlg:text-[16px] max-mlg:leading-[24px]
      max-xl:my-[15px]">
                  Mar 07, 2025
                </h3>
              </div>
              <Link
                href={
                  "/what-to-expect-a-simple-panchakarma-treatment-guide-for-2025"
                }
                className="absolute w-[100%] h-full left-[0px] top-[0px]"></Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
